import React, { useState } from "react";
import DeleteItemModal from "./DeleteItemModal";
import { deleteMonthlyParkingPayment } from "helpers/fakebackend_helper";

const DeleteItemButton = ({ id, token, reloadTime, itemLabel = "item" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const toggleModal = () => setIsOpen(!isOpen);

    const handleConfirm = async () => {
        if (!id) return;
        setLoading(true);
        await deleteMonthlyParkingPayment(token, id);
        reloadTime && reloadTime();
        setLoading(false);
        setIsOpen(false);
    };

    return (
        <>
            <i
                className="fas fa-trash text-danger"
                style={{ cursor: "pointer" }}
                onClick={toggleModal}
            ></i>

            <DeleteItemModal
                isOpen={isOpen}
                toggle={toggleModal}
                onConfirm={handleConfirm}
                itemLabel={itemLabel}
                loading={loading}
            />
        </>
    );
};

export default DeleteItemButton;